export const BACKEND_URL = 'https://back-owbasket.optimalwayconsulting.com';
export const ENVIRONMENT = 'prod';